const BASE_URL="https://api.checkout.et/api/"
const STORAGE_URL="https://api.checkout.et/storage/"
export {BASE_URL,STORAGE_URL};